import DynamicPage from 'components/DynamicPage';

const Privacy = () => {
  return(
    <DynamicPage url="/privacy-policy" />
  )
}

export default Privacy;
